import React from 'react';
import { Link } from 'react-router-dom';

const CtaBanner = () => (
  <section className="bg-[#DDE9E7] px-6 py-20 lg:px-8 lg:py-24">
    <div className="mx-auto grid max-w-7xl gap-9 lg:grid-cols-[1.15fr_.85fr] lg:items-end">
      <div>
        <p className="section-kicker">Ready when you are</p>
        <h2 className="mt-4 max-w-4xl text-[clamp(2.5rem,5vw,4.8rem)] font-semibold leading-[0.98] tracking-[-0.052em] text-[#102A3A]">Tell us what you want to build. We will tell you the clearest way to start.</h2>
      </div>
      <div className="max-w-lg lg:justify-self-end">
        <p className="text-base leading-7 text-[#52636E]">Bring the rough idea, the current website, or the manual process. The first conversation is about fit, scope, and the next useful step.</p>
        <div className="mt-7 flex flex-col gap-3 sm:flex-row">
          <Link to="/contact" className="button-primary inline-flex items-center justify-center gap-2">Start a project <span aria-hidden="true">&rarr;</span></Link>
          <a href="mailto:nexgeius@gmail.com" className="button-secondary inline-flex items-center justify-center">Email Nexgeius</a>
        </div>
        <a href="mailto:nexgeius@gmail.com" className="mt-5 inline-block text-sm font-semibold text-[#176B8A]">nexgeius@gmail.com</a>
      </div>
    </div>
  </section>
);

export default CtaBanner;
